// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"jV-z","inlineTitle":"kV-z","sponsoredAdsWrapper":"lV-z","marketplaceRecosWrapper":"mV-z"};